import { render } from "./FilePickerFile.vue?vue&type=template&id=737324d0&scoped=true"
import script from "./FilePickerFile.vue?vue&type=script&lang=js"
export * from "./FilePickerFile.vue?vue&type=script&lang=js"

import "./FilePickerFile.vue?vue&type=style&index=0&id=737324d0&scoped=true&lang=scss"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-737324d0"]])

export default __exports__